// Fires the Google Ads "LP Inquiry (WT)" conversion. Called on the
// form success ("thank you") state, which is the SPA equivalent of a
// dedicated thank-you page.
export function trackInquiryConversion() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", { send_to: "AW-976299820/mDCTCLmuso4cEKzOxNED" });
  }
}
